module.exports = __webpack_public_path__ + "media/images/proof_links/colored/twitter-8f662cde3e6a9aca24b77c1639d9423e.svg";